import React, { useContext, useEffect, useState } from 'react';
import * as S from './styles';
import { ScreenInovationType } from 'types/ScreenInovationType';
import SimpleInput from 'components/SimpleInput';
import InputImgBigger from 'components/InputImgBigger';
import { ImgSavedProps } from 'types/ImgSavedProps';
import SimpleTextArea from 'components/SimpleTextArea';
import { color } from 'styles/pallete';
import ScreensStaticContext from 'context/ScreensStaticContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import SystemNotifyContext from 'context/SystemNotifyContext';
import TitleForm from 'components/TitleForm';
import { ItemScreenStatic } from 'types/ScreensStaticsProps';
import { editStaticScreen } from 'components/FormSreenStatics/reqs';

type InovationFormProps = {
	closeModal: () => void;
};

const intialDataForm: ScreenInovationType = {
	mainImgUrl: '',
	secondImgUrl: '',
	lastImgUrl: '',
	title: '',
	description: '',
	btn: {
		textBtn: '',
		redirectBtn: ''
	}
};

export default function InovationForm({ closeModal }: InovationFormProps) {
	const { screens, setScreens } = useContext(ScreensStaticContext);
	const { setMessage, setIsOpenLoad } = useContext(LoadGeneralContext);
	const { handleNotify } = useContext(SystemNotifyContext);

	const [dataForm, setDataForm] = useState(intialDataForm);

	async function saveData() {
		let screenToEdit: ItemScreenStatic = { type: 'inovation', data: null };

		const newScreens = screens.map((value) => {
			if (value.type === 'inovation') {
				value.data = dataForm;
				screenToEdit = {
					...screenToEdit,
					data: dataForm,
					id: value?.id || '0'
				};
			}

			return value;
		});

		setIsOpenLoad(true);
		setMessage('Salvando dados');
		const isSuccess = await editStaticScreen(screenToEdit, handleNotify);
		setIsOpenLoad(false);

		if (isSuccess) {
			setScreens(newScreens);
			closeModal();
		}
	}

	useEffect(() => {
		const inovationScreen = screens.find(
			(screen) => screen.type === 'inovation'
		);

		if (inovationScreen) {
			setDataForm(inovationScreen.data as ScreenInovationType);
		}
	}, []);

	return (
		<S.container>
			<S.box>
				<S.forms>
					<TitleForm title="Imagens iniciais">
						<S.twoImgs>
							<InputImgBigger
								idImagem="mainImg"
								label="Primeira imagem"
								getImage={(value: ImgSavedProps) => {
									setDataForm((obj) => ({
										...obj,
										mainImgUrl: value?.url || ''
									}));
								}}
								initialImage={dataForm.mainImgUrl}
							/>

							<InputImgBigger
								idImagem="secondImg"
								label="Segunda imagem"
								getImage={(value: ImgSavedProps) => {
									setDataForm((obj) => ({
										...obj,
										secondImgUrl: value?.url || ''
									}));
								}}
								initialImage={dataForm.secondImgUrl}
							/>
						</S.twoImgs>
					</TitleForm>

					<TitleForm title="Informações">
						<S.twoInputsColumn>
							<SimpleInput
								label="Título"
								initialValue={dataForm.title}
								getValue={(value: string) => {
									setDataForm((obj) => ({ ...obj, title: value }));
								}}
							/>

							<SimpleTextArea
								title="Descrição"
								rows={6}
								borderColor={color.interface.lightGray2}
								colorFont={color.interface.lightGray}
								labelColor={color.interface.lightGray}
								textArea={dataForm.description}
								getValue={(value: string) => {
									setDataForm((obj) => ({ ...obj, description: value }));
								}}
							/>
						</S.twoInputsColumn>
					</TitleForm>

					<TitleForm title="Botão">
						<S.twoInputsRows>
							<SimpleInput
								label="Texto "
								initialValue={dataForm.btn.textBtn}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										btn: { ...obj.btn, textBtn: value }
									}));
								}}
							/>

							<SimpleInput
								label="Redirecionamento"
								initialValue={dataForm.btn.redirectBtn}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										btn: { ...obj.btn, redirectBtn: value }
									}));
								}}
							/>
						</S.twoInputsRows>
					</TitleForm>

					<TitleForm title="Última imagem">
						<InputImgBigger
							idImagem="lastImg"
							label="Imagem"
							getImage={(value: ImgSavedProps) => {
								setDataForm((obj) => ({
									...obj,
									lastImgUrl: value?.url || ''
								}));
							}}
							initialImage={dataForm.lastImgUrl}
						/>
					</TitleForm>
				</S.forms>
			</S.box>
			<S.containerBtns>
				<S.cancel
					data-testid="cancelBtn"
					onClick={() => {
						closeModal();
					}}
				>
					Cancelar
				</S.cancel>
				<S.save
					data-testid="saveBtn"
					onClick={() => {
						saveData();
					}}
				>
					Salvar
				</S.save>
			</S.containerBtns>
		</S.container>
	);
}
